import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {STATO_SPEDIZIONE, StatoSpedizione} from "../../../_helpers/stato-spedizione";

@Component({
    selector: 'app-select-stati-spedizioni',
    templateUrl: './select-stati-spedizioni.component.html',
    styleUrls: ['./select-stati-spedizioni.component.scss'],
    standalone: false
})
export class SelectStatiSpedizioniComponent {
  @Input() statoSpedizione: StatoSpedizione;
  @Output() statoSpedizioneChange = new EventEmitter<StatoSpedizione>();
  statiSpedizioniItem = STATO_SPEDIZIONE;
  selectStatoSpedizione = (e: SelectCustomEvent) => this.statoSpedizioneChange.emit(+e.target.value);
}
